import React, {Component} from 'react';
import axios from "axios";

class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        document.title = 'Update password';
    }

    state = {
        formData: {
            newPassword: {
                value: '',
                isValid: true,
                message: null
            },
            currentPassword: {
                value: '',
                isValid: true,
                message: null
            }
        },
        confirmPassword: {
            value: '',
            isValid: true,
            message: null
        }
    };


    confirmNewPassword = (event) => {
        if (this.state.formData.newPassword.value !== event.target.value) {
            this.setState({
                confirmPassword: {
                    value: '',
                    isValid: false,
                    message: 'The password and confirmation do not match.'
                }
            })
        } else {
            this.setState({
                confirmPassword: {
                    value: '',
                    isValid: true,
                    message: null
                }
            })
        }
    };


    formSubmit = (event) => {
        event.preventDefault();

        const data = {
            currentPassword: this.state.formData.currentPassword.value,
            newPassword: this.state.formData.newPassword.value
        };

        axios.post('/api/users/updatepassword', data)
            .then((response) => {
                this.props.history.push('/');
            })
            .catch((error) => {
                if (error.response.status === 400) {
                    this.setState({
                        formData: {
                            newPassword: {
                                value: this.state.formData.newPassword.value,
                                isValid: true,
                                message: null
                            },
                            currentPassword: {
                                value: this.state.formData.currentPassword.value,
                                isValid: false,
                                message: 'The current password specified is incorrect.'
                            }
                        }
                    });
                } else {
                    console.log('itt', error);
                }
            });
    };

    inputChangeHandler = event => {
        const value = event.target.value;
        const fieldName = event.target.name;
        const updatedFormData = {...this.state.formData};
        updatedFormData[fieldName] = {
            value: value,
            isValid: true,
            message: null
        };
        this.setState({formData: updatedFormData})
    };


    render() {
        const bgStyle = {
            backgroundImage: "url('../assets/img/wallpaper-tumblr-pc-awesome-yukle-1200x851-travel-background-tumblr-pc-most-beautiful-of-wallpaper-tumblr-pc.jpg')",
            marginTop: "-20px",
            backgroundSize: "cover",
            backgroundPosition: "top center"
        };

        return (
            <div className="page-header header-filter"
                 style={bgStyle}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 ml-auto mr-auto">
                            <div className="card card-login">
                                <form className="form" onSubmit={this.formSubmit}>
                                    <h3 className="card-title">Update password</h3>
                                    <br/>
                                    <div className="card-body">
                                        <div className="form-group bmd-form-group">
                                            <label className="bmd-label-static">Current password</label>
                                            <input
                                                required
                                                className={this.state.formData.currentPassword.isValid ? "form-control" : "form-control is-invalid"}
                                                type="password"
                                                name="currentPassword"
                                                onChange={this.inputChangeHandler}
                                            />
                                            <small className="form-text text-danger">{this.state.formData.currentPassword.message}</small>
                                        </div>
                                        <br/>
                                        <div className="form-group bmd-form-group ">
                                            <label className="bmd-label-static">New password</label>
                                            <input
                                                required
                                                className="form-control"
                                                type="password"
                                                name="newPassword"
                                                onChange={this.inputChangeHandler}
                                            />
                                        </div>
                                        <br/>
                                        <div className="form-group bmd-form-group">
                                            <label className="bmd-label-static">Confirm Password</label>
                                            <input
                                                required
                                                className={this.state.confirmPassword.isValid ? "form-control" : "form-control is-invalid"}
                                                type="password"
                                                name="confirmPassword"
                                                onChange={this.confirmNewPassword}
                                            />
                                            <small className="form-text text-danger">{this.state.confirmPassword.message}</small>
                                        </div>
                                    </div>
                                    <br/>
                                    <br/>
                                    <button type="submit" className="btn btn-primary">Update password</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default UpdatePassword;


// WEBPACK FOOTER //
// ./src/containers/UpdatePassword/UpdatePassword.jsx